const LAYOUT_ACTIONS = {
  SET: 'set',
}

export default LAYOUT_ACTIONS
